<div #canvasRootElement class="
    w-full h-full
    bg-green-500/0
    ">

    <canvas #canvasElement></canvas>

</div>
